import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
const StackContext = React.createContext({});
export function ModalStackProvider({ children }) {
    const [stack, setStack] = React.useState([]);
    const pushToStack = React.useCallback((key) => {
        setStack(stack => [...stack, key]);
    }, []);
    const removeFromStack = React.useCallback((key) => {
        setStack(stack => stack.filter(item => item !== key));
    }, []);
    return (_jsx(StackContext.Provider, { value: { stack, pushToStack, removeFromStack }, children: children }));
}
export const useModalStack = (notInStack = false, onChange) => {
    const onChangeRef = React.useRef(onChange);
    onChangeRef.current = onChange;
    const { stack, pushToStack, removeFromStack } = React.useContext(StackContext);
    const key = React.useMemo(() => Symbol(), []);
    React.useEffect(() => {
        if (notInStack)
            return;
        pushToStack(key);
        return () => removeFromStack(key);
    }, [notInStack, pushToStack, removeFromStack, key]);
    const isTop = notInStack || stack[stack.length - 1] === key;
    React.useEffect(() => {
        onChangeRef.current?.(isTop);
    }, [isTop]);
    return { isTop };
};
export const useModalStackLength = () => {
    const { stack } = React.useContext(StackContext);
    return stack.length;
};
//# sourceMappingURL=ModalStack.js.map